var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 9H10.875C10.6562 9 10.5 8.84375 10.5 8.625V8.375C10.5 8.1875 10.6562 8 10.875 8H16.125C16.3125 8 16.5 8.1875 16.5 8.375V8.625C16.5 8.84375 16.3125 9 16.125 9ZM16.5 10.625C16.5 10.8438 16.3125 11 16.125 11H10.875C10.6562 11 10.5 10.8438 10.5 10.625V10.375C10.5 10.1875 10.6562 10 10.875 10H16.125C16.3125 10 16.5 10.1875 16.5 10.375V10.625ZM18.5 19H18.625C18.8125 19 19 19.1875 19 19.375V19.625C19 19.8438 18.8125 20 18.625 20H7.5C6.09375 20 5 18.9062 5 17.5V6.5C5 5.125 6.09375 4 7.5 4H18.25C18.6562 4 19 4.34375 19 4.75V16.25C19 16.5625 18.7812 16.8438 18.5312 16.9688C18.4062 17.4688 18.375 18.375 18.5 19ZM9 16H18V5H9V16ZM6 16.5C6.40625 16.1875 6.9375 16 7.5 16H8V5H7.5C6.65625 5 6 5.6875 6 6.5V16.5ZM17.625 19C17.5312 18.375 17.5312 17.5938 17.625 17H7.5C5.5 17 5.5 19 7.5 19H17.625Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBook);
export default __webpack_public_path__ + "static/media/help-book.7061da2b.svg";
export { ForwardRef as ReactComponent };